export interface HttpError {
  errorCode: number;
  errorType: ErrorType;
}

export enum ErrorType {
  BUSINESS_LOGIC, // Internal error due to business logic, e.g., invalid user input
  TECHNICAL, // System error, e.g., network issues, server errors, our code bugs
}
